import React from 'react';

import { UpcomingGroup as UpcomingGroupType } from 'components/FinancialCheckup/FinancialDashboard/UpcomingSection/useUpcomingData';
import UpcomingItem from 'components/FinancialCheckup/FinancialDashboard/UpcomingSection/UpcomingItem/UpcomingItem';

import styles from './UpcomingGroup.module.scss';

interface UpcomingGroupProps {
  group: UpcomingGroupType;
}

const UpcomingGroup: React.FC<UpcomingGroupProps> = ({ group }) => (
  <li className={styles.group}>
    <p className={styles.groupLabel}>{group.label}</p>
    <ul className={styles.items}>
      {group.items.map((item, index) => (
        <li key={index} className={styles.item}>
          <UpcomingItem item={item} />
        </li>
      ))}
    </ul>
  </li>
);

export default UpcomingGroup;
